module.exports = __webpack_public_path__ + "static/media/starterguidestep4.57499f12.png";